/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Mediaslider_Download1Inputs */

const id_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduh`)
};

const ms_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat turun`)
};

const da_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const de_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herunterladen`)
};

const en_us2_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const es_es2_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar`)
};

const es_mx2_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar`)
};

const fil_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-download`)
};

const fr_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger`)
};

const it_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica`)
};

const hu_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letöltés`)
};

const nl_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloaden`)
};

const no_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last ned`)
};

const pl_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobierz`)
};

const pt_br2_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const pt_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregar`)
};

const ro_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descărcare`)
};

const fi_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa`)
};

const sv_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda ner`)
};

const vi_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải xuống`)
};

const tr_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İndir`)
};

const cs_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stáhnout`)
};

const bg_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтегляне`)
};

const ru_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать`)
};

const uk_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажити`)
};

const ar_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنزيل`)
};

const hi_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डाउनलोड`)
};

const th_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดาวน์โหลด`)
};

const ja_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダウンロード`)
};

const zh_cn2_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const zh_hant1_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const ko_components_mediaslider_download1 = /** @type {(inputs: Components_Mediaslider_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Components_Mediaslider_Download1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_mediaslider_download1 = /** @type {((inputs?: Components_Mediaslider_Download1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Mediaslider_Download1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_mediaslider_download1(inputs)
	if (locale === "ms") return ms_components_mediaslider_download1(inputs)
	if (locale === "da") return da_components_mediaslider_download1(inputs)
	if (locale === "de") return de_components_mediaslider_download1(inputs)
	if (locale === "en-US") return en_us2_components_mediaslider_download1(inputs)
	if (locale === "es-ES") return es_es2_components_mediaslider_download1(inputs)
	if (locale === "es-MX") return es_mx2_components_mediaslider_download1(inputs)
	if (locale === "fil") return fil_components_mediaslider_download1(inputs)
	if (locale === "fr") return fr_components_mediaslider_download1(inputs)
	if (locale === "it") return it_components_mediaslider_download1(inputs)
	if (locale === "hu") return hu_components_mediaslider_download1(inputs)
	if (locale === "nl") return nl_components_mediaslider_download1(inputs)
	if (locale === "no") return no_components_mediaslider_download1(inputs)
	if (locale === "pl") return pl_components_mediaslider_download1(inputs)
	if (locale === "pt-BR") return pt_br2_components_mediaslider_download1(inputs)
	if (locale === "pt") return pt_components_mediaslider_download1(inputs)
	if (locale === "ro") return ro_components_mediaslider_download1(inputs)
	if (locale === "fi") return fi_components_mediaslider_download1(inputs)
	if (locale === "sv") return sv_components_mediaslider_download1(inputs)
	if (locale === "vi") return vi_components_mediaslider_download1(inputs)
	if (locale === "tr") return tr_components_mediaslider_download1(inputs)
	if (locale === "cs") return cs_components_mediaslider_download1(inputs)
	if (locale === "bg") return bg_components_mediaslider_download1(inputs)
	if (locale === "ru") return ru_components_mediaslider_download1(inputs)
	if (locale === "uk") return uk_components_mediaslider_download1(inputs)
	if (locale === "ar") return ar_components_mediaslider_download1(inputs)
	if (locale === "hi") return hi_components_mediaslider_download1(inputs)
	if (locale === "th") return th_components_mediaslider_download1(inputs)
	if (locale === "ja") return ja_components_mediaslider_download1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_mediaslider_download1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_mediaslider_download1(inputs)
	return ko_components_mediaslider_download1(inputs)
});
export { components_mediaslider_download1 as "components.mediaSlider.download" }